import React, { useContext, useEffect, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import OButton from "components/reusable/OButton";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import dayjs from "dayjs";
import Pagination from "../Pagination";
import AuthContext from "context/AuthContext";
import { useTranslation } from "react-i18next";
import FinalEmployeeTable from "./FinalEmployeeTable";
import EmployeeView from "./EmployeeView";
import helpers from "../../utils/helpers";
import CustomSelect from "components/reusable/CustomSelect";
import { categoryOptions } from "utils/constants";
import { useLocation } from "react-router-dom";
import OSearch from "components/reusable/OSearch";
import EmployeeIpModal from "../all_employee/EmployeeIpModal";
import EmployeeWageSetup from "./EmployeeWageSetup";

const FinalEmployeeList = () => {
  const { updatePageName } = useContext(AuthContext);
  const location = useLocation();
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [employeeList, setEmployeeList] = useState([]);
  const [currentItem, setCurrentItem] = useState("");
  const [employeeView, setEmployeeView] = useState(false);
  const [ipModalView, setIpModalView] = useState(false);
  const [wageSetupView, setWageSetupView] = useState(false); // ═══ ADDED ═══
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [filterData, setFilterData] = useState({
    category: "",
    searchKey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sortBy: "createdAt",
    sortType: "desc",
  });

  const handleView = (item) => {
    setCurrentItem(item);
    setEmployeeView(!employeeView);
  };

  const handleGeoIp = (item) => {
    setCurrentItem(item);
    setIpModalView(true);
  };

  // ═══ ADDED: Handle wage setup ═══
  const handleWageSetup = (item) => {
    setCurrentItem(item);
    setWageSetupView(true);
  };

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true);
    } else if (searchTerm || !filterData?.isReset) {
      setFilterData({
        ...filterData,
        isReset: false,
        searchKey: helpers?.ternaryCondition(debouncedSearchTerm, debouncedSearchTerm, ""),
        isFilter: helpers?.ternaryCondition(debouncedSearchTerm, true, false),
      });
      setPage(1);
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTerm]);

  const allEmployeeList = async (data) => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData;
      if ((data?.deletePage && employeeList?.length >= 1) || (isFilter && category && data?.statusChange && employeeList?.length >= 1)) {
        setPage(page - 1);
        setPaginationObj({ ...paginationObj, page: page - 1 });
      }

      const payload = {
        page,
        pageSize,
        formStatus: category,
        startDate: helpers?.ternaryCondition(startDate, dayjs(startDate).format("YYYY-MM-DD"), null),
        endDate: helpers?.ternaryCondition(endDate, dayjs(endDate).format("YYYY-MM-DD"), null),
        keyword: searchKey?.trim(),
        sortBy: sort.sortBy,
        sortType: sort.sortType,
      };
      const path = apiPath.finalAccountantEmployeeList;
      const result = await apiGet(path, payload);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      setEmployeeList(response?.docs);
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(resultStatus, response.totalPages, null),
        perPageItem: helpers?.ternaryCondition(resultStatus, response?.docs.length, null),
        totalItems: helpers?.ternaryCondition(resultStatus, response.totalDocs, null),
      });
    } catch (error) {
      console.log("error in get all employee list==>>>>", error.message);
    }
  };

  useEffect(() => {
    allEmployeeList();
  }, [filterData, sort, page]);

  const handleReset = () => {
    setFilterData({
      category: "",
      searchKey: "",
      startDate: "",
      endDate: "",
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    setSearchTerm("");
  };

  useEffect(() => {
    updatePageName(t("NAV_ALL_EMPLOYEE_LIST"));
  }, []);

  useEffect(() => {
    if (location.state) setFilterData({ ...filterData, category: location.state });
  }, [location.state]);

  const handleDateChange = (start, end) => {
    setPage(1);
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };

  const statusPage = (e) => {
    setFilterData({ ...filterData, category: e.target.value, isFilter: true });
    setPage(1);
  };

  return (
    <>
      {" "}
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3">
              <div className="col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0">
                <div className="flex items-center lg:pt-0 pt-3 flex-wrap ">
                  <div className="relative flex items-center mb-3 w-[340px]">
                    <OSearch searchTerm={searchTerm} setSearchTerm={setSearchTerm} placeholder={t("SEARCH_BY_EMPLOYEE_NAME_DEPARTMENT")} />
                  </div>
                  <ODateRangePicker handleDateChange={handleDateChange} isReset={filterData?.isReset} setIsReset={setFilterData} />
                  <CustomSelect id="category" name="category" value={filterData.category} onChange={statusPage} options={categoryOptions} placeholder="O_ALL" t={t} />
                  <OButton label="Reset" type="button" onClick={handleReset} extraClasses="ml-3 mb-3" style={{ borderRadius: "0.5rem" }} />
                </div>
              </div>
            </form>
            <FinalEmployeeTable
              employeeList={employeeList}
              allEmployeeList={allEmployeeList}
              page={page}
              handleView={handleView}
              handleGeoIp={handleGeoIp}
              handleWageSetup={handleWageSetup}  // ═══ ADDED ═══
              currentItem={currentItem}
              employeeView={employeeView}
              setSort={setSort}
              sort={sort}
            />
            {employeeView && <EmployeeView employeeView={employeeView} setEmployeeView={setEmployeeView} currentItem={currentItem} handleView={handleView} />}

            {/* ═══ ADDED: Wage Setup Modal ═══ */}
            {wageSetupView && (
              <EmployeeWageSetup
                employeeId={currentItem?.Employee?._id || currentItem?.employeeID}
                onClose={() => setWageSetupView(false)}
              />
            )}

            {ipModalView && (
              <EmployeeIpModal
                item={currentItem}
                onClose={() => setIpModalView(false)}
              />
            )}
            {paginationObj?.totalItems ? <Pagination handlePageClick={handlePageClick} options={paginationObj} page={page} /> : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default FinalEmployeeList;





// import React, { useContext, useEffect, useState } from "react";
// import { apiGet } from "../../utils/apiFetch";
// import apiPath from "../../utils/apiPath";
// import OButton from "components/reusable/OButton";
// import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
// import dayjs from "dayjs";
// import Pagination from "../Pagination";
// import AuthContext from "context/AuthContext";
// import { useTranslation } from "react-i18next";
// import FinalEmployeeTable from "./FinalEmployeeTable";
// import EmployeeView from "./EmployeeView";
// import helpers from "../../utils/helpers";
// import CustomSelect from "components/reusable/CustomSelect";
// import { categoryOptions } from "utils/constants";
// import { useLocation } from "react-router-dom";
// import OSearch from "components/reusable/OSearch";
// import EmployeeIpModal from "../all_employee/EmployeeIpModal";

// const FinalEmployeeList = () => {
//   const { updatePageName } = useContext(AuthContext);
//   const location = useLocation();
//   const { t } = useTranslation();
//   const [page, setPage] = useState(1);
//   const [pageSize] = useState(10);
//   const [paginationObj, setPaginationObj] = useState({
//     page: 1,
//     pageCount: 1,
//     pageRangeDisplayed: 10,
//   });
//   const [employeeList, setEmployeeList] = useState([]);
//   const [currentItem, setCurrentItem] = useState("");
//   const [employeeView, setEmployeeView] = useState(false);
//   const [ipModalView, setIpModalView] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
//   const [isInitialized, setIsInitialized] = useState(false);
//   const [filterData, setFilterData] = useState({
//     category: "",
//     searchKey: "",
//     startDate: "",
//     endDate: "",
//     isReset: false,
//     isFilter: false,
//   });
//   const [sort, setSort] = useState({
//     sortBy: "createdAt",
//     sortType: "desc",
//   });

//   const handleView = (item) => {
//     setCurrentItem(item);
//     setEmployeeView(!employeeView);
//   };

//   const handleGeoIp = (item) => {
//     setCurrentItem(item);
//     setIpModalView(true);
//   };

//   const handlePageClick = (event) => {
//     const newPage = event.selected + 1;
//     setPage(newPage);
//   };

//   useEffect(() => {
//     if (!isInitialized) {
//       setIsInitialized(true);
//     } else if (searchTerm || !filterData?.isReset) {
//       setFilterData({
//         ...filterData,
//         isReset: false,
//         searchKey: helpers?.ternaryCondition(debouncedSearchTerm, debouncedSearchTerm, ""),
//         isFilter: helpers?.ternaryCondition(debouncedSearchTerm, true, false),
//       });
//       setPage(1);
//     }
//   }, [debouncedSearchTerm]);

//   useEffect(() => {
//     const timeoutId = setTimeout(() => {
//       setDebouncedSearchTerm(searchTerm);
//     }, 500);
//     return () => {
//       clearTimeout(timeoutId);
//     };
//   }, [searchTerm]);

//   const allEmployeeList = async (data) => {
//     try {
//       const { category, startDate, endDate, searchKey, isFilter } = filterData;
//       if ((data?.deletePage && employeeList?.length >= 1) || (isFilter && category && data?.statusChange && employeeList?.length >= 1)) {
//         setPage(page - 1);
//         setPaginationObj({ ...paginationObj, page: page - 1 });
//       }

//       const payload = {
//         page,
//         pageSize,
//         formStatus: category,
//         startDate: helpers?.ternaryCondition(startDate, dayjs(startDate).format("YYYY-MM-DD"), null),
//         endDate: helpers?.ternaryCondition(endDate, dayjs(endDate).format("YYYY-MM-DD"), null),
//         keyword: searchKey?.trim(),
//         sortBy: sort.sortBy,
//         sortType: sort.sortType,
//       };
//       const path = apiPath.finalAccountantEmployeeList;
//       const result = await apiGet(path, payload);
//       const response = result?.data?.results;
//       const resultStatus = result?.data?.success;
//       setEmployeeList(response?.docs);
//       setPaginationObj({
//         ...paginationObj,
//         page: helpers?.ternaryCondition(resultStatus, response.page, null),
//         pageCount: helpers?.ternaryCondition(resultStatus, response.totalPages, null),
//         perPageItem: helpers?.ternaryCondition(resultStatus, response?.docs.length, null),
//         totalItems: helpers?.ternaryCondition(resultStatus, response.totalDocs, null),
//       });
//     } catch (error) {
//       console.log("error in get all employee list==>>>>", error.message);
//     }
//   };

//   useEffect(() => {
//     allEmployeeList();
//   }, [filterData, sort, page]);

//   const handleReset = () => {
//     setFilterData({
//       category: "",
//       searchKey: "",
//       startDate: "",
//       endDate: "",
//       isReset: true,
//       isFilter: false,
//     });
//     setPage(1);
//     setSearchTerm("");
//   };

//   useEffect(() => {
//     updatePageName(t("NAV_ALL_EMPLOYEE_LIST"));
//   }, []);

//   useEffect(() => {
//     if (location.state) setFilterData({ ...filterData, category: location.state });
//   }, [location.state]);

//   const handleDateChange = (start, end) => {
//     setPage(1);
//     setFilterData({
//       ...filterData,
//       startDate: start,
//       endDate: end,
//       isFilter: true,
//     });
//   };

//   const statusPage = (e) => {
//     setFilterData({ ...filterData, category: e.target.value, isFilter: true });
//     setPage(1);
//   };

//   return (
//     <>
//       {" "}
//       <div className="bg-[#F9F9F9]">
//         <div className="px-3 py-4">
//           <div className="bg-white border border-[#E9EDF9] rounded-lg">
//             <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3">
//               <div className="col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0">
//                 <div className="flex items-center lg:pt-0 pt-3 flex-wrap ">
//                   <div className="relative flex items-center mb-3 w-[340px]">
//                     <OSearch searchTerm={searchTerm} setSearchTerm={setSearchTerm} placeholder={t("SEARCH_BY_EMPLOYEE_NAME_DEPARTMENT")} />
//                   </div>
//                   <ODateRangePicker handleDateChange={handleDateChange} isReset={filterData?.isReset} setIsReset={setFilterData} />
//                   <CustomSelect id="category" name="category" value={filterData.category} onChange={statusPage} options={categoryOptions} placeholder="O_ALL" t={t} />
//                   <OButton label="Reset" type="button" onClick={handleReset} extraClasses="ml-3 mb-3" style={{ borderRadius: "0.5rem" }} />
//                 </div>
//               </div>
//             </form>
//             <FinalEmployeeTable employeeList={employeeList} allEmployeeList={allEmployeeList} page={page} handleView={handleView} handleGeoIp={handleGeoIp} currentItem={currentItem} employeeView={employeeView} setSort={setSort} sort={sort} />
//             {employeeView && <EmployeeView employeeView={employeeView} setEmployeeView={setEmployeeView} currentItem={currentItem} handleView={handleView} />}
//             {ipModalView && (
//               <EmployeeIpModal
//                 item={currentItem}
//                 onClose={() => setIpModalView(false)}
//               />
//             )}
//             {paginationObj?.totalItems ? <Pagination handlePageClick={handlePageClick} options={paginationObj} page={page} /> : null}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default FinalEmployeeList;
